export const products = [{ id: 'professionalReport', url: '/professional-report' }];

export const individualProducts = [
  { id: 'paymentHistory', url: '/payment-history', hidden: true, permission: '' },
  { id: 'openDebts', url: '/open-debts', hidden: true, permission: '' },
  { id: 'professionalReport', url: '/professional-report', permission: '/product/personprofessionalreport/' },
  { id: 'personsRegister', url: '/persons-register', hidden: true, permission: '' },
];
